exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".withdrawal-title[data-v-87254fb2]{margin-bottom:16px}.withdrawal-description[data-v-87254fb2]{margin-bottom:32px;font-size:14px}.honeypot-field[data-v-87254fb2]{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-87254fb2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/Withdrawal.vue
// module id = 604
// module chunks = 0